import { Map } from 'immutable'
import {
  VN_CARD_READER_ERROR,
  VN_DEBUGGER_ENABLED,
  VN_SIMULATED_DISCONNECTION,
  VN_DEBUGGER_PASSTHROUGH_ENABLED,
  VN_DEBUGGER_PASSTHROUGH_MESSAGE,
} from './ActionTypes'

const initialState = () => {
  return Map({
    simulateDisconnection: false,
    VNDebuggerEnabled: false,
    cardReaderError: false,
    debuggerPassthroughEnabled: false,
    debuggerPassthroughMessage: {},
  })
}

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case VN_DEBUGGER_ENABLED:
      return {
        ...state,
        VNDebuggerEnabled: action.data,
      }
    case VN_SIMULATED_DISCONNECTION:
      return {
        ...state,
        simulateDisconnection: action.data,
      }
    case VN_CARD_READER_ERROR:
      return {
        ...state,
        cardReaderError: action.data,
      }
    case VN_DEBUGGER_PASSTHROUGH_ENABLED:
      return {
        ...state,
        debuggerPassthroughEnabled: action.data,
      }
    case VN_DEBUGGER_PASSTHROUGH_MESSAGE:
      return {
        ...state,
        debuggerPassthroughMessage: action.data,
      }
    default:
      return state
  }
}

export default reducer
